// docs: https://github.com/altostra/type-validations#readme
import { recordOf } from "@altostra/type-validations";
import { boolean } from "@altostra/type-validations/lib/primitives";

import type { BannersDismissResult } from "./types";

/**
 * Validator for BannersDismissResult - validates an object where keys are banner IDs (strings)
 * and values are booleans indicating whether each banner has been dismissed.
 */
export const isBannersDismissResult = recordOf<BannersDismissResult>(boolean);
